// --------------------------------------------

// -- 下層ページ用 画面遷移時のアニメーションを処理

// --------------------------------------------

export default class lowlayerTransition {
    constructor(effect,ease) {

        this.$container = document.getElementById("l-kv")

        this.$target;

        this.status = [];
        this.conf = {
            num : 0,
            ease : ease
        };

        this.effect = effect;

    }
    init(){

        this.$target = document.getElementsByClassName('js__trans-lowlayer');
        this.conf.num = this.$target.length;


        TweenLite.set(this.$target,{y:100,opacity:0});


    }
    motion(filterID,stageID,type){

        let _y,_op;

        if(!document.getElementById(stageID)) return;

        if(type=="out"){
            TweenMax.to(this.$container,0.4,{y:0});
            document.getElementById(stageID).classList.add("is-show");
            _y = 0;
            _op = 1;
        }else{
            document.getElementById(stageID).classList.remove("is-show")
            _y = 100;
            _op = 0;
        }


        for(let i=0; this.conf.num>i; i++){
            let $t = this.$target[i];
            if(filterID==$t.getAttribute("data-id")){
                if(type=="in") TweenMax.killTweensOf($t);
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "y":_y,
                    "opacity":_op,
                    "ease":this.conf.ease[type].type
                });
            }
        }



    }
    render(mouse,scrollInc){

    }
    resize(display){

    }
}